import { Component, Input, Output, EventEmitter, ViewChild, input, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { Table, TableLazyLoadEvent, TableModule } from 'primeng/table';
import { CheckboxModule } from 'primeng/checkbox';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SelectModule } from 'primeng/select';
import {ConfirmPopupModule} from 'primeng/confirmpopup';
import {ConfirmationService, MessageService} from 'primeng/api';
import { ObservableInput } from 'ngx-observable-input';
import { never, Observable, of } from 'rxjs';
import { signal } from '@angular/core';
import { AppKeyValuePair } from '../../interfaces/AppKeyValuePair';
import { MyMonitoringService } from '../../../services/logging.service';

@Component({
  selector: 'app-table',
  standalone: true,
  imports: [CheckboxModule, ButtonModule, CommonModule, FormsModule, TableModule, SelectModule, ConfirmPopupModule],
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
  providers: [ConfirmationService, MessageService],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TableComponent implements OnInit{
  constructor(
    private confirmationService: ConfirmationService, 
    private messageService: MessageService,
    private monotoringService: MyMonitoringService,
  ) {
    
  }

  @ViewChild('dt2') dt2: Table | undefined;    
  @Input() actionButtons: any[] = [];
  @Input() columns: any[] = [];
  @Input() rows$!: Observable<any[]>;
   data: any[] = [];
  @Input() showCheckAll: boolean = false;
  @Input() SingleRowSelection: boolean = false;
  @Input() showCheckRowColumn: boolean = false;
  @Input() rowsPerPageOptions: any[] = [10, 20, 30, 40, 50];
  @Input() pageSize: number = 10; 
  @Input() overridePageSize: boolean = false; 
  @Input() totalRecords: number = 2000;
  @Input() paginator: boolean = true; 
  @Input() ShowAlternateRowColor: boolean = true;
  @Input() AlternateRowColor: string = "whitesmoke";
  @Output() selectionChange = new EventEmitter<any>(); 
  @Output() onRowSelected = new EventEmitter<any>(); 
  @Output() onRowUnselected = new EventEmitter<any>(); 
  @Output() saveClick = new EventEmitter<any>(); 
  @Output() downloadClick = new EventEmitter<any>(); 
  @Output() onEditComplete = new EventEmitter<any>(); 
  @Output() onAction1ButtonClicked = new EventEmitter<any>(); 
  @Output() onAction2ButtonClicked = new EventEmitter<any>(); 
  @Output() onAction3ButtonClicked = new EventEmitter<any>(); 
  @Output() onAction4ButtonClicked = new EventEmitter<any>(); 
  @Output() onAction5ButtonClicked = new EventEmitter<any>(); 
  @Output() onCellClicked = new EventEmitter<any>(); 

@Input() pageNumber: number = 1;


  @Output() pageChanged = new EventEmitter<{ page: number, pageSize: number }>();
  @Output() sortClicked = new EventEmitter<{ sortField: string | string[] | null | undefined, sortOrder: number | null | undefined}>();
   @Output() onSearchText = new EventEmitter<{ searchText: any}>();

  selectedRows: any[] = []; 
  @Input() searchValue: string = '';
  modifiedRows: any[] = [];
  changedRows: any[] = [];
  selectedItems: any[] = [];
  filteredColumns: any[] = [];
  tablePageSize: number = 5;
  
ngOnInit(){
  /*
  this.tablePageSize = this.overridePageSize === true ? this.pageSize : 
                          screen.height <= 618 ? Math.min(3, this.pageSize) :
                            screen.height <= 720 ? Math.min(5, this.pageSize) : 
                              screen.height <= 864 ? Math.min(10, this.pageSize) : 
                                screen.height <= 1080 ? Math.min(15, this.pageSize) : this.pageSize;
  this.filteredColumns = this.columns.filter(x => x.isVisible !== false);

  this.selectedRows = [];
  this.selectedItems = [];
  this.rows$.subscribe((items) => {
    this.data = items;
  });
  */
 
}


  loadData($event: TableLazyLoadEvent)
  {    
    if($event.sortField != undefined)
    {      
      this.sortClicked.emit({ sortField: $event.sortField, sortOrder: $event.sortOrder });
    }
    
    this.tablePageSize = this.overridePageSize === true ? this.pageSize : 
                            screen.height <= 618 ? Math.min(3, this.pageSize) :
                              screen.height <= 720 ? Math.min(5, this.pageSize) : 
                                screen.height <= 864 ? Math.min(10, this.pageSize) : 
                                  screen.height <= 1080 ? Math.min(15, this.pageSize) : this.pageSize;
    this.filteredColumns = this.columns.filter(x => x.isVisible !== false);

    this.selectedRows = [];
    this.selectedItems = [];
    this.rows$.subscribe((items) => {
      this.data = items;
    });
  }

  resetPage() {
    if (this.dt2) {
      this.dt2.first = 0;
      this.dt2.firstChange.emit(0);
    }
  }

  cellClicked(columnName: any, columnValue: any) {
  this.onCellClicked.emit([columnName, columnValue]);
  }

  onPageChanged(event: any): void {
  console.log(event);
  const pageSize = event.rows;
  const pageIndex = event.first / pageSize;
  const pageNumber = pageIndex + 1;
  this.pageChanged.emit({ page: pageNumber, pageSize });
}

  clear() {
    this.dt2?.clear();
    this.searchValue = '';
    this.selectedRows = [];
    this.selectedItems = [];
  }

  filterTable(value:string) {    
    this.onSearchText.emit({searchText: value});        
  }

  getColumnFields() {    
    return this.columns.map((item:any) => item?.field);
  }

  // onRowSelect(event: any) {
  //   const changedRow = event.data;
  //   const existingRowIndex = this.selectedRows.findIndex(row => row === changedRow);
  //   if (existingRowIndex > -1) {
  //     this.selectedRows[existingRowIndex] = this.rows$[existingRowIndex];
  //   } else {
  //     this.selectedRows.push(changedRow);
  //   }
  //   this.onRowSelected.emit(this.selectedRows); 
  // }

  onRowSelect(event: any) {
    const changedRow = event.data;
    this.rows$.subscribe(rows => {
      const existingRowIndex = this.selectedRows.findIndex(row => row === changedRow);     
      if (existingRowIndex > -1) {
        this.selectedRows[existingRowIndex] = rows[existingRowIndex]; 
      } else {
        this.selectedRows.push(changedRow);
      }
      this.onRowSelected.emit(this.selectedRows);
    });
  }

  onRowUnselect(event: any) {
    const changedRow = event.data;
    const existingRowIndex = this.selectedRows.findIndex(row => row === changedRow);
    this.selectedRows.splice(existingRowIndex, 1);
    this.onRowUnselected.emit(this.selectedRows); 
  }

  onSelectionChange(selected: any) {
    this.selectionChange.emit(selected.data);
  }

  onRowEditComplete(event: any) {
    const changedRow = event.data;
    if (changedRow != null) {
      this.rows$.subscribe((rows) => {
        const existingRowIndex = this.selectedItems.findIndex(row => row === changedRow);
        if (existingRowIndex > -1) {
          this.selectedItems[existingRowIndex] = changedRow;
        } else {
          this.selectedItems.push(changedRow);
        }
        this.onEditComplete.emit(this.selectedItems);
      });
    }
  }
  onSaveClicked(event: Event){
    this.confirmationService.confirm({
      message: 'Are you sure that you want to proceed?',
      icon: 'pi pi-question',
      
      accept: () => {
          this.messageService.add({severity:'info', summary:'Confirmed', detail:'You have accepted'});
          this.saveClick.emit(this.selectedItems);
      },
      reject: () => {
          this.messageService.add({severity:'error', summary:'Rejected', detail:'You have rejected'});
      }
  });
  }

  // ondownloadClicked(){
  //   this.downloadClick.emit(this.rows);
  // }

  ondownloadClicked() {
    this.rows$.subscribe((rows) => {
      this.downloadClick.emit(rows);
    });
  }
  
  onAction1ButtonClick(event: Event){
    this.confirmationService.confirm({
      message: 'Are you sure that you want to proceed?',
      icon: 'pi pi-question',
      acceptButtonStyleClass: 'custom-accept-button',
      rejectButtonStyleClass: 'custom-reject-button',
      accept: () => {
          this.messageService.add({severity:'info', summary:'Confirmed', detail:'You have accepted'});
          this.onAction1ButtonClicked.emit(this.selectedItems);
      },
      reject: () => {
          this.messageService.add({severity:'error', summary:'Rejected', detail:'You have rejected'});
      }
  });
  }

  onAction2ButtonClick(event: Event){
    this.confirmationService.confirm({
      message: 'Are you sure that you want to proceed?',
      icon: 'pi pi-question',
      acceptButtonStyleClass: 'custom-accept-button',
      rejectButtonStyleClass: 'custom-reject-button',
      accept: () => {
          this.messageService.add({severity:'info', summary:'Confirmed', detail:'You have accepted'});
          this.onAction2ButtonClicked.emit();
      },
      reject: () => {
          this.messageService.add({severity:'error', summary:'Rejected', detail:'You have rejected'});
      }
  });
  }

  onAction3ButtonClick(event: Event){
    this.confirmationService.confirm({
      message: 'Are you sure that you want to proceed?',
      icon: 'pi pi-question',
      accept: () => {
          this.messageService.add({severity:'info', summary:'Confirmed', detail:'You have accepted'});
          this.onAction3ButtonClicked.emit();
      },
      reject: () => {
          this.messageService.add({severity:'error', summary:'Rejected', detail:'You have rejected'});
      }
  });
  }

  onAction4ButtonClick(event: Event){
    this.confirmationService.confirm({
      message: 'Are you sure that you want to proceed?',
      icon: 'pi pi-question',
      accept: () => {
          this.messageService.add({severity:'info', summary:'Confirmed', detail:'You have accepted'});
          this.onAction4ButtonClicked.emit();
      },
      reject: () => {
          this.messageService.add({severity:'error', summary:'Rejected', detail:'You have rejected'});
      }
  });
  }

  onAction5ButtonClick(event: Event){
    this.confirmationService.confirm({
      message: 'Are you sure that you want to proceed?',
      icon: 'pi pi-question',
      accept: () => {
          this.messageService.add({severity:'info', summary:'Confirmed', detail:'You have accepted'});
          this.onAction5ButtonClicked.emit();
      },
      reject: () => {
          this.messageService.add({severity:'error', summary:'Rejected', detail:'You have rejected'});
      }
  });
  }

  getOptionsLabelDesc(options: AppKeyValuePair[], value: any) : AppKeyValuePair[] {
    const option = options.filter(op => op.value === value);
    return option;
  }
  
}



function $any(target: any) {
  throw new Error('Function not implemented.');
  
}
